import React from 'react'
import { Link } from 'react-router-dom'
import { MdEdit } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export default class ListSendMailComponent extends React.Component {


	render() {
		return (
			<tr>
				<td>
					<Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.send_mail.user_id}>{this.props.send_mail.user_name}</Link>
				</td>
				<td>
					<Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.send_mail.user_id}>{this.props.send_mail.user_email}</Link>
				</td>
				<td>{ this.props.send_mail.type_send_mail }</td>
				<td>{ this.props.send_mail.subject }</td>
				<td className={'text-center'}>{ this.props.send_mail.dateCreated }</td>
				<td>
					{
						this.props.send_mail.status ? (
							<div className="text-success" dangerouslySetInnerHTML={{ __html: this.props.send_mail.status_text }} />
						) : (
							<div className="text-danger">{this.props.send_mail.status_text}</div>
						)
					}
					
				</td>

				<td className={'text-center'}>
					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chi tiết
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Button 
	    					className="btn btn-warning btn-sm m-1"
							onClick={ () => this.props.showModal(this.props.actionKey, 'detail') }
						>
							<MdEdit />
					  	</Button>
				  	</OverlayTrigger>
				  	
				</td>
			</tr>
		)
	}
}